const ROUTERS = {
  INTRO: `/`,
  HOME: `/home`,
  LOGIN: `/login`,
  FORGOT_PW: `/forgot-password`,
  INFORMATION_POLICY : '/information-policy',
  INFORMATION_TERM : '/information-term',
  VIDEO_MESSAGE_MAKER: `/video/message-maker`,
  VIDEO_MESSAGE_MAKER_STEP: `/video/message-maker-step/:step`,
  VIDEO_MESSAGE_MAKER_STEP_PATH: (step) => `/video/message-maker-step/${step}`,
  VIDEO_COUPON_BOX: `/video/message-maker-step/coupon-box`,
  VIDEO_COMPLETED: `/video/completed`,
  INFORMATION: `/information`,
  CAMERA: `/camera`,
  GIFT: `/gift`,
  ALBUM: `/album`,
  REGISTER: `/register`,
  CHILDREN_SETTING: `/setting/children`,
  ALBUM_DETAIL: `/album/detail/:step`,
  ALBUM_DETAIL_PATH: (id) => `/album/detail/${id}`,
  GIFTBOX: `/giftbox`,
  GIFTBOX_POINT: `/giftbox/point`,
  GIFTBOX_POINT_HISTORY: `/giftbox/point/history`,
  GIFTBOX_COUPONS: `/giftbox/coupons`,
  VIDEO_DETAIL: `/video/detail/:id`,
  VIDEO_DETAIL_PATH: (id) => `/video/detail/${id}`,
  VIDEO_PLAYER: `/video/player/:id`,
  VIDEO_PLAYER_PATH: (id) => `/video/player/${id}`,
  NOTIFICATION: `/notification`,
  PROFILE : '/setting/profile',
  NOTIFICATION_DETAIL:`/notification/:id`,
  CHANGE_PASSWORD : '/setting/change-password',
  AWARD: `/award`,
  AWARD_REGISTER: `/award/register`,
  AWARD_VOTING: `/award/voting`,
  NOTIFICATION_SETTING : '/setting/notification',
  QNA_CREATE:`/qna/create`,
  QNA_DETAIL:`/qna/:id`,
  QNA:`/qna`,
  FAQ:`/faq`,
  INFORMATION_SERVICE_COMPANY: `/information-service-company`,
  INFORMATION_SERVICE_TERM: `/information-service-term`,
  INFORMATION_SERVICE_POLICY: `/information-service-policy`,
  IFRAME: `/iframe`,
  VIDEO_RECOMMEND_DETAIL: `/video-recommend/detail/:id`,
  VIDEO_RECOMMEND_DETAIL_PATH: (id) => `/video-recommend/detail/${id}`,
  VIDEO_RECOMMEND_PLAYER: `/video-recommend/player/:id`,
  VIDEO_RECOMMEND_PLAYER_PATH: (id) => `/video-recommend/player/${id}`,
};
export default ROUTERS;
